// angular
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { SelfEvaluationService } from '../self-evaluation.service';
import { AuthService } from '../../core/auth.service';

// others
import { SelectionComponent } from '../selection.component';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
declare var window:any;

@Component({
    templateUrl: 'amnestic-feeling-selection.component.html',
    styleUrls: ['../self-evaluation.component.scss']
})
export class AmnesticFeelingSelectionComponent extends SelectionComponent implements OnInit, OnDestroy {
    currentStep: number;
    pageName = this.STEPS.ANAMESTIC_SELECTION;
    apiRoute: string;

    constructor(
        public elementRef: ElementRef,
        public service: SelfEvaluationService,
        public router: Router,
        public route: ActivatedRoute,
        public authService: AuthService,
        public appService: AppService,
        public coreService: CoreService,
        public translateService : TranslateService
    ) {
        super(elementRef, service, router, route, authService, appService, coreService, translateService);
    }

    ngOnInit() {
        this.appService.setCurrentSeStep(this.appService.SEType === this.pageTypes.repeatedSE.type ? this.appService.repeatSteps.ANAMESTIC_SELECTION : this.appService.steps.ANAMESTIC_SELECTION);
        this.deviceInnerHeight = this.appService.deviceInnerHeight;
        this.lang = this.translateService.currentLang;

        // Step 4 isAcute always = 0
        this.isAcute = 0;
        this.currentStep = this.appService.steps.ANAMESTIC_SELECTION;
        super.ngOnInit();
        this.initStartTime();
        this.setSEType();

        // Prevent Back and refresh
        this.noBackPlease();
        window.onbeforeunload = this.popupReload;
        window.onkeydown = this.preventBack;

    }

    submitSelection(goNextStep = 0, cb: any = false) {
        this.isLoading = true;

        // On Step 4 : Rating not allowed
        const activePage = this.activePage;
        let feelings = {};

        this.itemsGroup.forEach(function (group, index) {

            if ((index + 1) > activePage) {
                return;
            }

            group.forEach(function (item) {
                if(item.patient_questionnaire_feeling_id){
                    feelings[item.patient_questionnaire_feeling_id] = item.selected ? 1 : 0;
                }
            });
        });

        this.service.submit(this.apiUpdateRoute, {
            smoke_detectors: this.selectedIds,
            feelings: feelings,
            is_finish: goNextStep,
            token: this.token,
            is_acute: this.isAcute,
            next_item : (this.itemPerPage * this.activePage) + 1
            // next_page : goNextStep ? this.activePage + 1 : this.activePage
        }).subscribe((rs) => {

            if (rs['success'] && goNextStep) {
                this.nextStep = true;
                this.stepNavigate(0);
            }
            this.isLoading = false;

            if (typeof cb === 'function') {
                cb();
            }
        });
    }

    setIsRedirectedFromAmnestic() {
        this.service.isRedirectedFromAmnestic = true;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
